export default __webpack_public_path__ + "static/5-f8b4c361b5861cec7f285c256bebab55.jpg";